import WeaveUi from './weave-ui';

export default class Panelbar extends WeaveUi {
    constructor() {
        super();
        this.$elements = {
            panelContainer: $('<article class="weave-panels hidden"></article>'),
            panelLink: $('<a class="weave-open-panel-link"></a>'),
            contentContainer: $('<div class="weave-panel"></div>'),
            icon: $('<div class="weave-icon"></div>')
        };
        let $panelBars = $('.panel-bar');
        var that = this;
        for (var i = 0; i < $panelBars.length; i++) {
            var $this = $($panelBars[i]);
            that.buildPanelBar($this);
        }
        this.events();
    }

    buildPanelBar($panelBar) {
        let $panelContainer = this.$elements.panelContainer.clone();
        $panelContainer.append(this.$elements.panelLink.clone());
        let that = this;
        let $linkSections = $panelBar.find('[data-content="link-section"]');
        var $panelLink = $panelContainer.find('.weave-open-panel-link');
        for (var i = 0; i < $linkSections.length; i++) {
            var $this = $($linkSections[i]);
            $panelLink.append($this);
        }
        $panelLink.append(this.$elements.icon);
        $panelContainer.append(this.$elements.contentContainer.clone());
        var $contentContainer = $panelContainer.find('.weave-panel');
        $contentContainer.append($panelBar.find('div[data-content="panel-content"]'));
        $panelBar.after($panelContainer);
        $panelBar.hide();
    }

    events() {
        $('body').on('click', '.weave-open-panel-link', function() {
            var $this = $(this);
            var $expectedPanel = $this.parent().find(".weave-panel").first(),
                alternatePanelLocation = $this.attr('data-panel-name'),
                $panel;

            if ($expectedPanel.length > 0) {
                $panel = $expectedPanel;
            } else if (alternatePanelLocation !== "") {
                $panel = $('[data-tray-location=' + alternatePanelLocation + ']');
            }

            if ($panel.length > 0) {
                if ($panel.parent().parent().attr('data-only-one-open') && !$panel.hasClass('open')) {
                    $('.weave-panel').removeClass('open').prev().removeClass('open');
                }
                if ($panel.attr('data-animate') === "true") {
                    if ($panel.is(':visible')) {
                        $panel.slideUp(parseInt($panel.attr('data-animation-speed-up')));
                    } else {
                        $panel.slideDown(parseInt($panel.attr('data-animation-speed-down')));
                    }
                } else {
                    $panel.toggleClass("open");
                }
                $this.toggleClass("open");
                $panel.find('div[data-content="panel-content"]').removeClass('hidden');
            }
        });
    }
}


// WEBPACK FOOTER //
// ./js/weave-ui/panelbar.js